import { Box, Typography, Card } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const StyledCard = styled(Card)(({ theme }) => ({
  border: '1px solid #EAECEF',
  borderRadius: theme.spacing(2),
  boxShadow: 'none',
  padding: theme.spacing(3)
}));

interface StatCardProps {
  label: string;
  value: string | number;
  change?: number; // percentage change
  trend?: 'up' | 'down';
}

const StatCard = ({ label, value, change, trend }: StatCardProps) => {
  const isPositive = trend === 'up';
  
  return (
    <StyledCard>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 500,
          fontSize: '1rem',
          color: 'text.primary',
          mb: 1
        }}
      >
        {label}
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            fontSize: '2rem',
            letterSpacing: '-0.02em',
            color: 'text.primary'
          }}
        >
          {value}
        </Typography>
        
        {change !== undefined && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: isPositive ? '#16A34A' : '#DC2626'
            }}
          >
            {isPositive ? (
              <TrendingUp sx={{ fontSize: 18 }} />
            ) : (
              <TrendingDown sx={{ fontSize: 18 }} />
            )}
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                ml: 0.5
              }}
            >
              {Math.abs(change)}%
            </Typography>
          </Box>
        )}
      </Box>
    </StyledCard>
  );
};

export default StatCard;

